import InfiniteScroll from "react-infinite-scroll-component";
import DlightKenyaDataBody from "./DlightKenyaDataBody";
import ScrollToTop from "components/common/ScrollToTop/ScrollToTop";
import DlightKenyaDataHeader from "./DlightKenyaDataHeader";
import classNames from "classnames";
import { useEffect, createRef } from "react";
import * as styles from "./DlightKenya.module.scss";
import {
  storeScrollPosition,
  fetchStoredScrollPosition,
} from "common/utils/utils";

const DlightKenyaDataTable = ({
  fetchNextPage,
  lastPage,
  hasNextPage,
  dlightKenyaData,
  isLoading,
  noDataFound,
  extraClass,
}) => {
  const tableRef = createRef();

  const tableclasses = classNames(
    "Table_Wrapper",
    styles[extraClass],
    styles.List_Scroll_Table
  );
  const containerClasses = { overflow: "default" };

  useEffect(() => {
    setTimeout(() => {
      fetchStoredScrollPosition("scrollable-table", "DLIGHT_KENYA");
    }, 100);
  }, []);

  return (
    <section id="scrollable-table" className={tableclasses} ref={tableRef}>
      <InfiniteScroll
        style={containerClasses}
        loader={!isLoading && <h4 className="Font_H8">Loading...</h4>}
        next={fetchNextPage}
        dataLength={isLoading ? 0 : lastPage * dlightKenyaData.length}
        hasMore={hasNextPage}
        onScroll={(event) => storeScrollPosition(event, "DLIGHT_KENYA")}
        scrollableTarget="scrollable-table">
        <table className="Table overflow-auto">
          <DlightKenyaDataHeader />
          {!isLoading && !noDataFound && (
            <DlightKenyaDataBody {...{ dlightKenyaData }} />
          )}
        </table>
      </InfiniteScroll>
      <ScrollToTop />
    </section>
  );
};

export default DlightKenyaDataTable;
